module.exports = __webpack_public_path__ + "static/media/MaxiNutrition_Proteincoach-Step-5-Milch-img.5f8b3783.png";